import { forwardRef, memo } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = (_ref, ref) => {
  let {
    title,
    titleId,
    desc,
    descId,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    width: "1em",
    height: "1em",
    className: "interstate-building-office-icon",
    ref: ref,
    "aria-labelledby": titleId,
    "aria-describedby": descId,
    ...props,
    children: [desc ? /*#__PURE__*/_jsx("desc", {
      id: descId,
      children: desc
    }) : null, title ? /*#__PURE__*/_jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/_jsx("path", {
      d: "M1.337.754c0-.345.28-.625.625-.625h12.077a.625.625 0 01.02 1.25V14.62h.583a.625.625 0 010 1.25H1.358a.625.625 0 110-1.25h.582V1.378a.625.625 0 01-.603-.624zm1.853.625V14.62h1.77V12.53c0-.846.685-1.53 1.53-1.53h3.02c.845 0 1.53.684 1.53 1.53v2.092h1.77V1.38H3.19zm6.6 13.242V12.53a.28.28 0 00-.28-.28H6.49a.28.28 0 00-.28.28v2.092h3.58zM4.96 3.773c0-.345.28-.625.625-.625h1.207a.625.625 0 110 1.25H5.585a.625.625 0 01-.625-.625zm3.623 0c0-.345.28-.625.625-.625h1.207a.625.625 0 110 1.25H9.208a.625.625 0 01-.625-.625zM4.96 6.188c0-.345.28-.625.625-.625h1.207a.625.625 0 110 1.25H5.585a.625.625 0 01-.625-.625zm3.623 0c0-.345.28-.625.625-.625h1.207a.625.625 0 110 1.25H9.208a.625.625 0 01-.625-.625zM4.96 8.604c0-.345.28-.625.625-.625h1.207a.625.625 0 110 1.25H5.585a.625.625 0 01-.625-.625zm3.623 0c0-.345.28-.625.625-.625h1.207a.625.625 0 110 1.25H9.208a.625.625 0 01-.625-.625z"
    })]
  });
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
const Memo = /*#__PURE__*/memo(ForwardRef);

// eslint-disable-next-line react/no-multi-comp
export const BuildingOfficeIcon = /*#__PURE__*/forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx(Memo, {
    ...props,
    ref: ref
  });
});
BuildingOfficeIcon.displayName = 'BuildingOfficeIcon';